const invertedMessages = {
  'Close Breakdown': 'certs.close.breakdown',
};

export default invertedMessages;
